import {slideToggle} from '@roghz/slidetoggle';

const initNavigation = () => {
    const menuItems = document.querySelectorAll('.footer-main__nav > ul > li > a');

    menuItems.forEach(item => {
        item.addEventListener('click', (e) => {
            if (window.matchMedia('(max-width: 1023px)').matches) {
                e.preventDefault();
                item.classList.toggle('active');
                slideToggle(item.nextElementSibling);
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', initNavigation);
